import styled, { keyframes } from 'styled-components';

/**
 * This is a typed spinner and a simplified copy of the one in the UI so that there is some conisistency between the two apps.
 * It is slightly simpler to use and comes with the typing benefits.
 */
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.svg<{
  size?: string;
  margin?: string;
}>`
  animation: ${spin} 1s linear infinite;
  width: ${(props) => props.size || '16px'};
  height: ${(props) => props.size || '16px'};
  margin: ${(props) => props.margin || '0 8px'};

  & circle {
    opacity: 0.25;
  }

  & path {
    opacity: 0.75;
  }
`;

type LoadingSpinnerProps = {
  size?: string;
  margin?: string;
  color?: string;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = '16px',
  margin,
  color = 'currentColor',
}) => (
  <Spinner
    size={size}
    margin={margin}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="4" />
    <path
      fill={color}
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </Spinner>
);

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  width: 100%;
`;
